document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".accordion-box");

  accordionItems.forEach((item) => {
    const body = item.querySelector(".accordion-body");
    const header = item.querySelector(".accordion-header");
    const itemInner = item.querySelector(".accordion-item");

    item.addEventListener("click", function (e) {
      if (
        e.target.closest(".accordion-body") &&
        !e.target.closest(".accordion-header")
      ) {
        return;
      }

      const isOpen = body.classList.contains("d-block");

      accordionItems.forEach((otherItem) => {
        const otherBody = otherItem.querySelector(".accordion-body");
        const otherHeader = otherItem.querySelector(".accordion-header");
        const otherItemInner = otherItem.querySelector(".accordion-item");

        if (otherBody) {
          otherBody.classList.remove("d-block");
          otherBody.classList.add("d-none");
        }

        otherItem.classList.remove("open");
        otherItem.classList.add("close");

        if (otherItemInner) {
          otherItemInner.classList.remove("open");
          otherItemInner.classList.add("close");
        }

        if (otherHeader) {
          otherHeader.classList.remove("icon-rotate");
        }
      });

      if (!isOpen) {
        body.classList.remove("d-none");
        body.classList.add("d-block");

        item.classList.remove("close");
        item.classList.add("open");

        if (itemInner) {
          itemInner.classList.remove("close");
          itemInner.classList.add("open");
        }

        if (header) {
          header.classList.add("icon-rotate");
        }
      }
    });
  });

  // if (accordionItems.length > 0 && window.innerWidth > 991) {
  //   accordionItems[0].click();
  // }
});
